var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloppy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.75 21V14.75H7.25V21M18.5 21H3.5C2.11929 21 1 19.8807 1 18.5V3.5C1 2.11929 2.11929 1 3.5 1H13.7145C14.3775 1 15.0134 1.26339 15.4823 1.73224L20.2677 6.51776C20.7366 6.98661 21 7.62249 21 8.28554V18.5C21 19.8807 19.8807 21 18.5 21Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppy);
export default __webpack_public_path__ + "static/media/floppy.768739abbeceeabe07950787296203fb.svg";
export { ForwardRef as ReactComponent };